import $ from 'jquery';
// a basic accordion. on load
$( function() {
  $( '.accordion .title' ).on( 'click', function( e ) {
    e.preventDefault();

    let $this = $( this );
    let $accordion = $this.parent();
    let $content = $this.next();

    $accordion.parent().find( '.content' ).css( 'max-height', '0' );

    if ($accordion.hasClass( 'open' ) ) {
      $accordion.removeClass( 'open' );

      // If this is an amenities accordion being closed, clear map popups and active states
      if ( $accordion.hasClass( 'amenities-accordion' ) ) {
        $( '#interactive-map .mapboxgl-popup' ).remove();
        $( '.amenity-points' ).removeClass( 'active' );
      }
    } else {
      // When opening an amenities accordion tab, close all map popups
      if ( $accordion.hasClass( 'amenities-accordion' ) ) {
        $( '#interactive-map .mapboxgl-popup' ).remove();
      }

      $accordion.siblings().removeClass( 'open' );
      $accordion.addClass( 'open' );
      $content.css( 'max-height', $content[0].scrollHeight );
    }
  });
})